
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface TherapistInfoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue?: () => void;
}

const TherapistInfoDialog = ({ 
  open, 
  onOpenChange,
  onContinue 
}: TherapistInfoDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Therapist Registration</DialogTitle>
          <DialogDescription>
            Important information about therapist registration
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-4">
          <p className="text-amber-600 font-medium">
            Please note: Therapist registration is by invitation only.
          </p>
          
          <p className="text-[#333B44]">
            Only therapists who confirm their credentials can be approved on our platform. 
            Your registration will be placed in a pending state while our team reviews your information.
          </p>
          
          <p className="text-[#333B44]">
            If you proceed, you'll be added to our system, but your account will remain inactive until 
            our administrators approve it. You'll receive an email notification once approval is complete.
          </p>
          
          <p className="text-[#333B44]">
            Interested in joining? Contact our Administrator at 
            <a href="mailto:administrator@clamalo.com" className="text-[#3BAFDA] hover:text-[#2E9AC4] hover:underline">administrator@clamalo.com</a> 
            for details on confirming your credentials.
          </p>
        </div>
        
        <DialogFooter className="flex justify-between gap-3">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button 
            onClick={() => {
              if (onContinue) {
                onContinue();
              } else {
                onOpenChange(false);
              }
            }}
            className="bg-[#333B44] hover:bg-[#1A6690]"
          >
            Proceed as Therapist
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TherapistInfoDialog;
